import { FCWithChildren } from '@types';
import React from 'react';
import useFitText from './use_fit_text';
import { useHistory } from 'react-router-dom';
import classNames from 'classnames';

import { Button } from '@components';
import useLayoutContext from '@hooks/useLayoutContext';
import useHandleRedirect from '@hooks/useHandleRedirect';

type WelcomeOptionsProps = {
  isSigningIn: boolean;
  welcome: string;
  toggleFlag: () => void;
};

const WelcomeOptions: FCWithChildren<WelcomeOptionsProps> = ({
  isSigningIn,
  welcome,
  toggleFlag,
}) => {
  const history = useHistory();
  const {
    isCaptivePortal,
    portalAccessUrl,
    isSso,
    authType,
    schoolUidName,
    redirectToLogin,
    showGuestLoginButton,
  } = useLayoutContext();

  useHandleRedirect();

  const register = () => {
    history.push(portalAccessUrl('/register'));
  };
  const guestVisitors = () => {
    history.push(portalAccessUrl('/guest-visitors'));
  };

  const containerCls = classNames(
    isCaptivePortal
      ? 'absolute top-0 left-0 right-0 bg-white p-3 flex justify-center'
      : [
          'flex flex-col items-center bg-white py-8 w-full md:w-1/2',
          isSigningIn ? 'rounded-l-md' : 'md:shadow-xl rounded-md',
        ],
  );

  const boxHeight = () => {
    const windowInnerWidth = window.innerWidth;
    if (windowInnerWidth >= 1280) {
      return 90;
    } else if (windowInnerWidth >= 1024) {
      return 75;
    }
    return 60;
  };

  const largeSizedFont = () => {
    const windowInnerWidth = window.innerWidth;
    if (windowInnerWidth > 1280) {
      return 187;
    }
    return 125;
  };

  const { fontSize, ref } = useFitText({ maxFontSize: largeSizedFont() });

  return (
    <div className={containerCls}>
      <div className="flex flex-col w-full space-y-2 md:w-4/5 md:max-w-lg">
        <h1 ref={ref} style={{ fontSize, maxHeight: boxHeight(), width: '100%' }}>
          {welcome}
        </h1>
        <span className="text-xs font-light">
          Create an account to get your devices on residential Wi-Fi
        </span>

        <div className="flex flex-col w-full mt-2 divide-y">
          {!isSso && (
            <Button className={`my-4 font-black ${isSigningIn ? 'mt-8' : ''}`} onClick={register}>
              Create Account
            </Button>
          )}

          {!isSigningIn && (
            <>
              <div className="h-4"></div>
              <Button
                layout="secondary"
                onClick={() =>
                  redirectToLogin(() => {
                    toggleFlag();
                  })
                }
              >
                {authType === 'sso' && schoolUidName !== ''
                  ? `Sign In ( ${schoolUidName} )`
                  : `Sign In`}
              </Button>
            </>
          )}
          <div className="w-full flex flex-row justify-end">
            <Button
              layout="link"
              className="mt-2 text-xs text-right"
              onClick={() => {
                isSso
                  ? history.push('/support')
                  : !isSso && !isSigningIn
                  ? history.push(portalAccessUrl('/forgot-password'))
                  : history.push('/');
              }}
            >
              {isSso ? 'Need help with sign-in?' : 'Forgot Username or Password?'}
            </Button>
          </div>

          {showGuestLoginButton && (
            <>
              <div className="h-4"></div>
              <Button layout="secondary" onClick={guestVisitors}>
                Guests and Visitors
              </Button>
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default WelcomeOptions;
